import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldSlugByIdVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type ApiWorldSlugById = { world: { slug: string } | null };



export const ApiWorldSlugByIdDocument = /*#__PURE__*/ `
    query WorldSlugById($id: Int!) {
  world(id: $id) {
    slug
  }
}
    `;

export const useWorldSlugById = <
      TData = ApiWorldSlugById,
      TError = ClientError
    >(
      variables: ApiWorldSlugByIdVariables,
      options?: Omit<UseQueryOptions<ApiWorldSlugById, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldSlugById, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldSlugById, TError, TData>(
      {
    queryKey: ['WorldSlugById', variables],
    queryFn: apiFetcher<ApiWorldSlugById, ApiWorldSlugByIdVariables>(ApiWorldSlugByIdDocument, variables),
    ...options
  }
    )};

useWorldSlugById.getKey = (variables: ApiWorldSlugByIdVariables) => ['WorldSlugById', variables];

export const useInfiniteWorldSlugById = <
      TData = InfiniteData<ApiWorldSlugById>,
      TError = ClientError
    >(
      variables: ApiWorldSlugByIdVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldSlugById, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldSlugById, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldSlugById, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldSlugById.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldSlugById, ApiWorldSlugByIdVariables>(ApiWorldSlugByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldSlugById.getKey = (variables: ApiWorldSlugByIdVariables) => ['WorldSlugById.infinite', variables];


useWorldSlugById.fetcher = (variables: ApiWorldSlugByIdVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldSlugById, ApiWorldSlugByIdVariables>(ApiWorldSlugByIdDocument, variables, options);
